<template>
    <span>
        <span class="no-wrap-string" v-show="consumption">• {{ consumption }}/{{$t('cat.product_tile.consumption.combined')}}</span>
        <span class="no-wrap-string" v-show="emissions">• CO<sub>2</sub> {{ emissions }} {{$t('cat.product_tile.co2_emission.unit')}}/km</span>
        <span class="no-wrap-string" v-show="co2class">• ( {{ co2class }} )</span>
    </span>
</template>

<script>
    export default {
        name: 'VehicleCardConsumption',
        props: {
            data: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                consumption: '',
                emissions: '',
                co2class: ''
            }
        },

        mounted() {
            //Check consumption
            if (this.data.consumptions) {
                if (this.data.consumptions.wltp_consumption_combined && this.data.consumptions.wltp_consumption_combined > 0.00) {
                    this.consumption = parseFloat(this.data.consumptions.wltp_consumption_combined).toString().replace('.', ',') + ' l';
                } else if (this.data.consumptions.wltp_fuel_consumption_weighted && this.data.consumptions.wltp_fuel_consumption_weighted > 0.00) {
                    this.consumption = parseFloat(this.data.consumptions.wltp_fuel_consumption_weighted).toString().replace('.', ',') + ' l';
                } else if (this.data.consumptions.wltp_power_consumption_combined && this.data.consumptions.wltp_power_consumption_combined > 0.00) {
                    this.consumption = parseFloat(this.data.consumptions.wltp_power_consumption_combined).toString().replace('.', ',') + ' kWh';
                } else {
                    this.consumption = false;
                }
            }

            //Check emissions
            if (this.data.co2_emissions) {
                if (this.data.co2_emissions.wltp_co2_emissions_weighted && this.data.co2_emissions.wltp_co2_emissions_weighted > 0.00) {
                    this.emissions = parseFloat(this.data.co2_emissions.wltp_co2_emissions_weighted).toString().replace('.', ',');
                } else if (this.data.co2_emissions.wltp_co2_emissions && this.data.co2_emissions.wltp_co2_emissions > 0.00) {
                    this.emissions = parseFloat(this.data.co2_emissions.wltp_co2_emissions).toString().replace('.', ',');
                } else {
                    this.emissions = false;
                }
            }

            //Check CO2 class
            if (this.data.co2_classes) {
                if (this.data.co2_classes.wltp_co2_class) {
                    this.co2class = this.data.co2_classes.wltp_co2_class.toUpperCase();
                } else if (this.data.co2_classes.wltp_co2_class_weighted_combined && this.data.co2_classes.wltp_co2_class_depleted_battery) {
                    this.co2class = this.data.co2_classes.wltp_co2_class_weighted_combined.toUpperCase() + '/' + this.data.co2_classes.wltp_co2_class_depleted_battery.toUpperCase();
                } else if (this.data.co2_classes.wltp_co2_class_weighted_combined) {
                    this.co2class = this.data.co2_classes.wltp_co2_class_weighted_combined.toUpperCase();
                } else if (this.data.co2_classes.wltp_co2_class_depleted_battery) {
                    this.co2class = this.data.co2_classes.wltp_co2_class_depleted_battery.toUpperCase();
                } else {
                    this.co2class = false;
                }
            }
        }
    }
</script>